import { Component, Host } from '@angular/core';
import { BllAccordionPanelComponent } from './accordion-panel.component';
import { BllExpandPanelHeaderComponent } from '../expand';

@Component({
  selector: 'bll-accordion-header',
  templateUrl: './accordion-header.component.html',
  host: {
    class: 'bll-accordion-header',
  },
})
export class BllAccordionPanelHeaderComponent extends BllExpandPanelHeaderComponent {
  get iconCenter(): boolean {
    return this.accordion.iconCenter;
  }

  get iconClass(): string {
    return this.accordion.iconClass;
  }

  get iconArrow() {
    return this.accordion.iconArrow;
  }

  get iconSize(): number {
    return this.accordion.iconSize;
  }

  constructor(@Host() public accordion: BllAccordionPanelComponent) {
    super(accordion);
  }
}
